// PrivateRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { Circles } from 'react-loader-spinner';

const PrivateRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUser] = useState(undefined);
    const [userInfoComplete, setUserInfoComplete] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setCurrentUser(user);
                setEmailVerified(user.emailVerified);
                
                const docRef = doc(db, 'users', user.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    const infoComplete = data.firstName?.trim() !== '' && data.lastName?.trim() !== '' && data.role?.trim() !== '';
                    setUserInfoComplete(infoComplete);
                } else {
                    setUserInfoComplete(false);
                }
            } else {
                setCurrentUser(null);
                setUserInfoComplete(false);
                setEmailVerified(false);
            }
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
          <div className="loading-overlay">
            <div className="loading-content">
              <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
              <p>Loading...</p>
            </div>
          </div>
        );
      }

    if (!currentUser) {
        return <Navigate to="/" />;
    }

    if (!emailVerified) {
        return <Navigate to="/login" />;
    }

    if (!userInfoComplete && window.location.pathname !== '/complete-info') {
        return <Navigate to="/complete-info" />;
    }

    return children;
};

export default PrivateRoute;
